import { ReactNode, memo, useMemo } from 'react';
import { MESSAGE_STATUS, useMessageContext } from 'react-easyrocket';
import { MessageDefault, MessageError, MessageSuccess } from 'src/components/svg/Massages';

interface MessageProps {
  id: string;
  text: string | ReactNode;
  status: MESSAGE_STATUS;
  closed: boolean;
}

const Message = ({ id, text, status }: MessageProps) => {
  const { closeMessage } = useMessageContext();

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const timeout = useMemo(
    () => (id ? setTimeout(closeMessage!, 8000, id) : null),
    [closeMessage, id, status]
  );

  const handleDeleteMessage = (messageId: string) => {
    if (timeout) {
      clearTimeout(timeout);
    }
    closeMessage?.(messageId);
  };

  const messageToShow = {
    info: <MessageDefault />,
    error: <MessageError />,
    success: <MessageSuccess />
  };

  return (
    <div
      className="bg-m_bg flex items-center self-center z-[101] transition-all top-5 rounded-[10px] px-5 py-2.5 text-m_text mt-4 cursor-pointer"
      onClick={() => handleDeleteMessage(id)}
      style={{ opacity: '1' }}>
      <div style={{ width: '20px' }}>{messageToShow[status]}</div>
      <div style={{ marginLeft: '14px', wordBreak: 'break-word', width: '100%' }}>{text}</div>
    </div>
  );
};

// eslint-disable-next-line no-restricted-exports
export default memo(Message);
